<ng-template #rhBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('document.save-document-first' | translate)
                : ('document.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'document.save-document-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #rhBlock
    [class]="'flex min-h-0 flex-1 flex-col w-full overflow-hidden'"
    [blocked]="isBlocked"
    [blockUi]="rhBlockUi"
>
    @if (model?.id) {
        <app-report-history-list
            [autoFocusSearch]="false"
            [(document)]="model"
        />
    }
</blockable-div>
